import React from "react";
import FactoidItem from "./FactoidItem";
import { cn } from "@/lib/utils";
import clsx from "clsx";

export type FactoidItemProps = {
  heading: string;
  blurb: string;
};

export type FactoidProps = {
  header: string;
  facts: FactoidItemProps[];
  theme?: string;
};

function Factoid({ header, facts, theme }: FactoidProps) {
  const baseClassName = "md:my-8 px-0";
  return (
    <div className="container px-0 flex flex-wrap w-full md:py-8 justify-center flex-col justify-center text-primary-500">
      <div
        className={cn(
          baseClassName,
          clsx({ "md:bg-putty-100": theme === "background-light" }),
        )}
      >
        {header && (
          <h2 className="hidden md:block text-center text-primary text-3xl md:text-[2.5rem] pb-6 m-0">
            {header}
          </h2>
        )}
        <div className="md:flex flex-nowrap m-auto">
          {facts.map((fact) => (
            <FactoidItem
              key={fact.heading}
              heading={fact.heading}
              blurb={fact.blurb}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Factoid;
